var hexRegex = /^#([A-F0-9]{6}|[A-F0-9]{3})$/i;
export var isHexColor = function (str) { return hexRegex.test(str); };
